import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {TradeQuoteItemError, TradeQuoteItemModel, TradeQuoteModel} from './trade-quote';
import {RequestApiService} from 'src/app/services/domain_code/request-api.service';
import {ApiRoutes} from 'src/app/services/apiroutes';
import {AuthService} from 'src/app/services/auth.service';
import {QuillEditorComponent} from 'ngx-quill';
import {TradeQuoteTableService} from './trade-quote-table.service';
import {LeaseRemarksList, LeaseDocuments} from 'src/app/models/lease-quote';
import {environment} from 'src/environments/environment';
import {QuoteChargeMaster, QuoteChargeMasterError, RequestQuotesChargesList} from '../base-quote.model';
import {WarningBoxComponent} from 'src/app/components/dialog-box/warning-box/warning-box.component';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'logzy-trade-quote-table',
    templateUrl: './trade-quote-table.component.html',
    styleUrls: ['./trade-quote-table.component.scss', '../lease-quote-table/lease-quote-table.component.scss']
})
export class TradeQuoteTableComponent implements OnInit {
    @Input()
    negotiate: boolean = true;

    @Input()
    refreshQuote = new BehaviorSubject(null);

    @Output()
    review: EventEmitter<any> = new EventEmitter();

    @Output()
    updateRequest: EventEmitter<any> = new EventEmitter();

    @ViewChild('editor', {static: false}) editor: QuillEditorComponent;

    modules = {};
    isCustomer: boolean;
    currentDate = new Date();
    tncExpand: boolean = true;

    downloadUrl = ApiRoutes.LeadRequest;
    location_url = `${ApiRoutes.Location}?location_type_name=port&search=::search::`;
    containerConditionLists = `${ApiRoutes.DomainCode}?group=ContainerCondition`;
    ralUrl = `${ApiRoutes.ContainerMaster}ral_master/?search=::search::`;

    uploadDocExpand: boolean = false;
    remarkExpand: boolean = true;

    consolidatedQuoteCharges: RequestQuotesChargesList[] = [];
    nonConsolidatedQuoteCharges: RequestQuotesChargesList[] = [];
    chargeMasterValidated: boolean = true;
    quoteChargeMasterValidated: boolean = true;
    chargeMasterPayload = [];
    @Input() requestDetails: any | undefined;
    default_currency: any;
    // remarks: string = '';
    // isInternal: boolean;
    // remarksList: LeaseRemarksList[] = [];
    // base_url = environment.baseApiUrl;
    // selectedDocument: LeaseDocuments = null;
    // selectedDocumentType: string = "";
    // showUpload: boolean = false;
    // documentTypeList: LeaseDocuments[] = [];
    rType: string = '';

    constructor(private authService: AuthService,
                public requestService: RequestApiService,
                public tradeQuoteTableService: TradeQuoteTableService,
                public dialog: MatDialog,
                private route: ActivatedRoute) {
        this.modules = {
            toolbar: false
        }
    }

    ngOnInit(): void {
        this.refreshComponent();
        this.getRequestQuoteCharges();

        this.route.queryParams.subscribe(params => {
            if ('id' in params || 'type' in params || 'rtype' in params) {
                // this.type = params['type'];
                this.rType = params['rtype'];
            }
        });

        this.refreshQuote.subscribe(item => {
            if (item == null) return;
            if (item == 'review') {
                this.reviewQuote(this.tradeQuoteTableService.baseQuote, true);
                return;
            }
            if (item == 'error') {
                this.tradeQuoteTableService.baseQuote.quote_items = [];
                for (let i = 0; i < this.requestService.selectedRequest.requirement.length; i++) {
                    this.tradeQuoteTableService.baseQuote.quote_items[i] = new TradeQuoteItemModel();
                    this.tradeQuoteTableService.baseQuote.error.quote_items[i] = new TradeQuoteItemError();
                    this.tradeQuoteTableService.baseQuote.quote_items[i].saveFirstPayload(this.requestService.selectedRequest.requirement[i]);
                    this.tradeQuoteTableService.baseQuote.quote_items[i].purchase_locations = this.requestService.selectedRequest.pols;
                }
            } else {
                this.tradeQuoteTableService.baseQuote = new TradeQuoteModel(item);
                this.tradeQuoteTableService.termsAndCondition = this.tradeQuoteTableService.baseQuote.terms_and_condition_fk;
                this.tradeQuoteTableService.selectedTermsAndCondition = this.tradeQuoteTableService.baseQuote.terms_and_condition_text;

                this.tradeQuoteTableService.baseQuote.quote_items.map(quote => {
                    quote.ad_hoc_charges.map(charge => charge.error = new QuoteChargeMasterError());
                })

                if (this.tradeQuoteTableService.baseQuote.ad_hoc_charges.length != 0) {
                    this.tradeQuoteTableService.baseQuote.ad_hoc_charges.map(charges => charges.error = new QuoteChargeMasterError());
                }
            }
            if (this.requestDetails.status.dev_name = 'received') {
                this.default_currency = this.requestDetails.requestor.company?.default_currency
                for (let i = 0; i < this.requestService.selectedRequest.requirement.length; i++) {
                    // this.tradeQuoteTableService.baseQuote.quote_items[i] = new TradeQuoteItemModel();
                    this.tradeQuoteTableService.baseQuote.quote_items[i]['price_currency'] = this.default_currency;
                    this.tradeQuoteTableService.baseQuote.quote_items[i]['storage_charge_currency'] = this.default_currency;
                }
            }
        });
    }

    refreshComponent() {
        this.refreshQuote.next(null);
        this.tradeQuoteTableService.baseQuote = new TradeQuoteModel();
        this.isCustomer = this.authService.isCustomer();
        this.getTermsAndConditionMasterList();
    }

    setPriceLabel() {
        if (this.requestService.selectedRequest?.transaction_type == 'use')
            return 'Buy-price*'
        else
            return 'Sell-price*'
    }

    getTermsAndConditionMasterList() {
        this.requestService.getTermsAndConditionsListLease(this.requestService.selectedRequest).subscribe({
            next: response => {
                this.tradeQuoteTableService.termsConditionList = response.results;

                if (this.tradeQuoteTableService.baseQuote.terms_and_condition_fk != null) {
                    this.tradeQuoteTableService.termsAndCondition = {
                        id: this.tradeQuoteTableService.termsConditionList.filter(item => item.id == this.tradeQuoteTableService.baseQuote.terms_and_condition_fk)[0].id,
                        name: this.tradeQuoteTableService.termsConditionList.filter(item => item.id == this.tradeQuoteTableService.baseQuote.terms_and_condition_fk)[0].name
                    };
                    this.tradeQuoteTableService.selectedTermsAndCondition = this.tradeQuoteTableService.baseQuote.terms_and_condition_text;
                } else {
                    this.tradeQuoteTableService.termsAndCondition = {
                        id: this.tradeQuoteTableService.termsConditionList[0].id,
                        name: this.tradeQuoteTableService.termsConditionList[0].name
                    };
                    this.tradeQuoteTableService.selectedTermsAndCondition = this.tradeQuoteTableService.termsConditionList[0].terms_condition;
                }
                return response;
            },
            error: error => {
                return error;
            }
        });
    }

    showCSCLabel() {
        for (let i = 0; i < this.tradeQuoteTableService.baseQuote?.quote_items.length; i++) {
            if (this.tradeQuoteTableService.baseQuote?.quote_items[i].csc_revalidation_required && !this.tradeQuoteTableService.baseQuote?.quote_items[i].csc_validation_included) {
                return true;
            } else {
                return false;
            }
        }
    }

    setRevalidationCharges(event, idx) {
        this.tradeQuoteTableService.baseQuote.quote_items[idx].csc_validation_included = event;
        if (event) {
            this.tradeQuoteTableService.baseQuote.quote_items[idx].csc_revalidation_charge = null;
        }
    }

    setTermsConditions() {
        if (this.tradeQuoteTableService.termsConditionList.length != 0) {
            this.tradeQuoteTableService.termsConditionList.map(item => {
                if (item.id == this.tradeQuoteTableService.termsAndCondition) {
                    this.tradeQuoteTableService.termsAndCondition = {
                        id: item.id,
                        name: item.name
                    };
                    this.tradeQuoteTableService.selectedTermsAndCondition = item.terms_condition;
                }
            });
        }
    }

    setTermsConditionspolicy(event) {
        if (event != null) {
            if (this.tradeQuoteTableService.baseQuote.terms_and_condition_text != event)
                this.tradeQuoteTableService.baseQuote.terms_and_condition_text = event
        }
    }

    reviewQuote(baseQuote, booking) {

        if (baseQuote.ad_hoc_charges.length != 0) {
            baseQuote.ad_hoc_charges.map(charge => {
                if (charge.amount == null || charge.amount_currency == null || charge.quote_charge == null)
                    this.chargeMasterValidated = false;
                else
                    this.chargeMasterValidated = true;
            });

            for (let i = 0; i < baseQuote.ad_hoc_charges.length; i++) {
                for (let k = i + 1; k < baseQuote.ad_hoc_charges.length; k++) {
                    if (baseQuote.ad_hoc_charges[i]?.quote_charge.id == baseQuote.ad_hoc_charges[k]?.quote_charge.id) {
                        this.openWarningDialog('Duplicate Request Quote Ad-hoc charge entries', '', 'Ok');
                        return;
                    }
                }
            }
        }

        if (!this.chargeMasterValidated) {
            this.openWarningDialog('Please select charge and enter all details 1', '', 'Ok');
            return;
        }

        let skipReview = false;

        baseQuote.quote_items.map(quote => {
            if (quote.ad_hoc_charges.length != 0) {
                quote.ad_hoc_charges.map(charge => {
                    if (charge.amount == null || charge.amount_currency == null || charge.quote_charge == null)
                        this.quoteChargeMasterValidated = false;
                    else
                        this.quoteChargeMasterValidated = true;
                });

                for (let i = 0; i < quote.ad_hoc_charges.length; i++) {
                    for (let k = i + 1; k < quote.ad_hoc_charges.length; k++) {
                        if (quote.ad_hoc_charges[i]?.quote_charge.id == quote.ad_hoc_charges[k]?.quote_charge.id) {
                            this.openWarningDialog('Duplicate Ad-hoc charge entries', '', 'Ok');
                            skipReview = true
                            return;
                        }
                    }
                }
            }
        });

        if (skipReview) return;

        if (!this.quoteChargeMasterValidated) {
            this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
            return;
        }

        this.requestService.confirmBooking = booking;
        baseQuote.terms_and_condition_fk = this.tradeQuoteTableService.termsAndCondition;
        baseQuote.terms_and_condition_text = this.tradeQuoteTableService.selectedTermsAndCondition;
        baseQuote.request = this.requestService.selectedRequest.id;
        this.review.emit(baseQuote);
    }

    openWarningDialog(label: string, description, action1: string, action2?: string, action3: string = null) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {
                subTitle: label,
                parent: this,
                description: description,
                label1: action1,
                label2: action2,
                label3: action3
            }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
            }
        })
    }

    saveQuote() {
        this.tradeQuoteTableService.saveQuotation().then(data => {
            this.updateRequest.emit();
        }).catch(error => {
            console.log(error);
        });
    }

    downloadQuote(quote) {
        window.open(`${this.downloadUrl}request_quotes/pdf/trade/${quote.id}/`, '_blank');
    }

    // getDocumentTypeList() {
    //     this.requestService.getDocumentTypeList('trade_quote').subscribe(res => {
    //         this.documentTypeList = res.results;
    //     })
    // }

    // showDocumentUpload(event) {
    //     this.selectedDocument = event;
    //     if (this.selectedDocument != null) {
    //         this.selectedDocumentType = this.selectedDocument.dev_name;
    //         this.showUpload = true;
    //     } else {
    //         this.showUpload = false;
    //     }
    // }

    cancelQuoteEditing() {
        this.updateRequest.emit();
    }

    getRequestQuoteCharges() {
        this.requestService.getRequestQuoteCharges(this.rType).subscribe(res => {
            if (res.length != 0) {
                console.log('getRequestQuoteCharges', res);
                this.consolidatedQuoteCharges = res.filter(charge => charge.is_consolidated_charge == true);
                this.nonConsolidatedQuoteCharges = res.filter(charge => charge.is_consolidated_charge == false);
            }
            console.log('this.consolidatedQuoteCharges', this.consolidatedQuoteCharges);
            console.log('this.nonConsolidatedQuoteCharges', this.nonConsolidatedQuoteCharges);
        })
    }

    addCharge() {
        this.tradeQuoteTableService.baseQuote.ad_hoc_charges.push(new QuoteChargeMaster())
    }

    removeCharge(idx) {
        this.tradeQuoteTableService.baseQuote.ad_hoc_charges.splice(idx, 1);
    }

    addQuoteItemCharge(quoteList) {
        quoteList.map(quote => {
            if (quote.ad_hoc_charges == undefined)
                quote.ad_hoc_charges = [];
            quote.ad_hoc_charges.push(new QuoteChargeMaster());
        })
    }

    removeQuoteItemCharge(quoteList, idx) {
        quoteList.map(quote => {
            quote.ad_hoc_charges.splice(idx, 1);
        })
    }
}
